import { render } from "./Species.vue?vue&type=template&id=0c906060&scoped=true"
import script from "./Species.vue?vue&type=script&lang=js"
export * from "./Species.vue?vue&type=script&lang=js"

import "./Species.vue?vue&type=style&index=0&id=0c906060&lang=scss&scoped=true"
import "./Species.vue?vue&type=style&index=1&id=0c906060&lang=scss"

import exportComponent from "/Users/khalid/Sites/sathoan/echosea/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c906060"]])

export default __exports__